export function getView(category_id, question_type) {
  return category_id !== 'habits' && question_type === 'boolean'
}
